<div class="container py-5">
    <h2>Preguntas Frecuentes</h2>
    <h5>¿SOSpect es gratuita?</h5>
    <p>Sí, la app es totalmente gratuita para todos los usuarios.</p>
    <h5>¿Dónde puedo reportar un problema?</h5>
    <p>Envíanos un correo a <a href="mailto:soporte@wescot.com.co">soporte&#64;wescot.com.co</a>.</p>
</div>